import React from "react";
import {DateFormatter} from "../../../../utils/DateFormatter.js";

export const DateCell = (props) => {
    const { dataItem, field, tdProps } = props;
    const value = dataItem?.[field];

    return (
        <td {...tdProps}>
            {DateFormatter.short(value)}
        </td>
    );
};